import React from 'react';
import PropTypes from 'prop-types';
import { FaThumbtack } from 'react-icons/fa';
import { getBoardPrimaryTag, getBoardTagConfig } from '../board/boardTagConfig';
import {
  formatBoardAnnouncementTimestamp,
  formatBoardRelativeTime,
  formatBoardUserDisplayName,
  formatBoardUserInitials,
} from '../board/boardDisplayUtils';

export function ClubBoardThreadHeader({ thread, timeIso, layout = 'card' }) {
  const primaryTag = getBoardPrimaryTag(thread?.tags);
  const tagCfg = getBoardTagConfig(primaryTag);
  const timeIsoResolved = timeIso || thread?.last_posted_at || thread?.updated_at || thread?.created_at;
  const timeLabel =
    primaryTag === 'announcement'
      ? formatBoardAnnouncementTimestamp(timeIsoResolved)
      : formatBoardRelativeTime(timeIsoResolved);
  const authorName = formatBoardUserDisplayName(thread?.created_by);
  const authorInitials = formatBoardUserInitials(thread?.created_by);

  if (layout === 'detail') {
    return (
      <div className="club-board-thread-detail__hero">
        <span className={`club-board-tag ${tagCfg.className}`}>{tagCfg.label}</span>
        {thread?.pinned ? (
          <span className="club-board-post__pinned club-board-post__pinned--inline">
            <FaThumbtack aria-hidden="true" />
            PINNED
          </span>
        ) : null}
        <h2 className="club-board-thread-detail__title">{thread.title}</h2>
        <div className="club-board-thread-detail__byline">
          <div className="club-board-post__avatar" aria-hidden="true">
            {authorInitials}
          </div>
          <div className="club-board-post__meta">
            <p className="club-board-post__author">{authorName}</p>
            {timeLabel ? <span className="club-board-post__time">{timeLabel}</span> : null}
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="club-board-post__header">
        <div className="club-board-post__avatar" aria-hidden="true">
          {authorInitials}
        </div>
        <div className="club-board-post__meta">
          <p className="club-board-post__author">{authorName}</p>
          {timeLabel ? <span className="club-board-post__time">{timeLabel}</span> : null}
        </div>
        {thread?.pinned ? (
          <span className="club-board-post__pinned">
            <FaThumbtack aria-hidden="true" />
            PINNED
          </span>
        ) : null}
      </div>
      <div className="club-board-post__content">
        <span className={`club-board-tag ${tagCfg.className}`}>{tagCfg.label}</span>
        <h4 className="club-board-post__title">{thread.title}</h4>
      </div>
    </>
  );
}

ClubBoardThreadHeader.propTypes = {
  thread: PropTypes.object.isRequired,
  timeIso: PropTypes.string,
  layout: PropTypes.oneOf(['card', 'detail']),
};
